import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { FilterReportData } from '../../../spd/containers/RegistersView/Filter';

export interface DownloadsFilesContextInterface {
  downloadFilesCompanySummary: (
    filename: string,
    filter: FilterReportData,
  ) => Promise<Blob>;
  downloadSalesInvoices: (
    filename: string,
    filter: FilterReportData,
  ) => Promise<Blob>;
}

export const DownloadsFilesContext = (api: DefaultApi) => {
  return {
    downloadFilesCompanySummary: async (
      filename: string,
      filter: FilterReportData,
    ) => {
      return await api.downloadsFilesControllerDownloadsFilesCompanySummary(
        filename,
        {
          ...filter,
        },
      );
    },
    downloadSalesInvoices: async (
      filename: string,
      filter: FilterReportData,
    ) => {
      return await api.downloadsFilesControllerDownloadsSalesInvoices(
        filename,
        {
          ...filter,
        },
      );
    },
  };
};
